import { LearningCenterResults } from "./learningcenter/learningcenter";
import { LearningCenterFilters } from "./learningcenter/learningcenterfilters";

new LearningCenterResults();
new LearningCenterFilters();


import { NewsList } from "./newslist/newslist";
new NewsList();


  import { SearchResults } from "./search/search";
  new SearchResults();